<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Logomark - EasyParcel box</b-card-title>
      </b-card-header>
      <b-card-body class="pb-1">
        <b-card-text>
          <p>EasyParcel box is our brand identity. You may use it with our wordmark or just standalone. It offers more flexibility than full logos as they are removed from the wordmark and allow accompanying information to live alongside the logomark in a way that keeps the information visually separate from the logo.</p>
        </b-card-text>
        <b-row
          class="match-height"
        >
          <b-col
            lg="6"
            md="6"
            sm="12"
            class="mb-2 text-center pr-0"
          >
            <div class="bg-light">
              <b-img
                :src="require('@/assets/images/logo/logomark-pink.svg')"
                class="w-25"
                alt="EasyParcel Logomark Pink"
              />
            </div>
            <small>Logomark pink</small>
          </b-col>
          <b-col
            lg="6"
            md="6"
            sm="12"
            class="mb-2 text-center pl-0"
          >
            <div class="bg-primary">
              <b-img
                :src="require('@/assets/images/logo/logomark-white.svg')"
                class="w-25"
                alt="EasyParcel Logomark White"
              />
            </div>
            <small>Logomark white</small>
          </b-col>
        </b-row>
        <ul class="list-style-icons">
          When to use logomark:
          <li>
            <feather-icon
              icon="CheckCircleIcon"
              class="text-success"
            />
            when additional information must be appended to or live closely alongside the logo
          </li>
          <li>
            <feather-icon
              icon="CheckCircleIcon"
              class="text-success"
            />
            when logo live in an environment where rendering the product name natively is more user friendly (such as a product UI component)
          </li>
          <li>
            <feather-icon
              icon="CheckCircleIcon"
              class="text-success"
            />
            when environmental restrictions do not allow for proper clearance guidelines to be followed for full logo
            <div class="text-center">
              <b-img
                :src="require('@/assets/images/logo/logomark-usage-example/logomark-usage-example1.png')"
                class="w-50 border-secondary border-lighten-5 rounded mt-1 mb-1"
                alt="EasyParcel Logomark usage example 1"
              />
            </div>
          </li>
          <li>
            <feather-icon
              icon="CheckCircleIcon"
              class="text-success"
            />
            when logo live within an external environment that mandates a container (such as external marketplaces, mobile app icons and so on)
            <div class="text-center">
              <b-img
                :src="require('@/assets/images/logo/logomark-usage-example/logomark-usage-example2.png')"
                class="w-50 border-secondary border-lighten-5 rounded mt-1 mb-1"
                alt="EasyParcel Logomark usage example 2"
              />
            </div>
          </li>
        </ul>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import {
  BCard, BImg, BCardHeader, BCardTitle, BCardBody, BCardText, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BImg,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
}
</script>
